import { Service } from '@/services/Service'
const ENDPOINTS = {
  GET: 'RepairTearDowns/Get',
  GET_DYNAMIC: 'RepairTearDowns/GetAllDynamic',
  POST: 'RepairTearDowns/Create',
  PATCH: 'RepairTearDowns/Patch',
  PUT: 'RepairTearDowns/Put',
  DELETE: 'RepairTearDowns/Delete'
}

class ModuleServiceRepairTearDowns extends Service {
  checkExistingEntity (data) {
    const { partSN, partID, rfqid } = data
    if (!partSN) return Promise.reject(new Error(`partSN is required`))
    if (!partID) return Promise.reject(new Error(`partID is required`))
    if (!rfqid) return Promise.reject(new Error(`rfqid is required`))

    return this.getAllDynamic({
      filter: [`partSN == "${partSN}"`, `partID == ${partID}`, `rfqid == "${rfqid}"`].join(' && ')
    })
      .then(({ data }) => {
        if (data.value.length > 0) {
          throw new Error(`Entity with partID == ${partID}, partSN == ${partSN}, rfqid == ${rfqid} => is already exist!`)
        }
      })
  }
  post (data) {
    return this.checkExistingEntity(data)
      .then(() => {
        return super.post(data)
      })
  }
}

export const ServiceRepairTearDowns = new ModuleServiceRepairTearDowns({
  apiGet: ENDPOINTS.GET,
  apiGetDynamic: ENDPOINTS.GET_DYNAMIC,
  apiPost: ENDPOINTS.POST,
  apiPatch: ENDPOINTS.PATCH,
  apiPut: ENDPOINTS.PUT,
  apiDelete: ENDPOINTS.DELETE
})
